import { collationRules } from 'json/mall-options'
export let tableLabels = [
  {
    label: '分组名称',
    value: 'name'
  },
  {
    label: '商品数量',
    value: 'goodsCount'
  },
  {
    label: '商品排序',
    value: 'sorting_strategy'
  },
  {
    label: '创建时间',
    value: 'created_date'
  },
  {
    label: '系统内置分组',
    value: 'isSsystem'
  },
  {
    label: 'C端是否展示',
    value: 'isVisible'
  }
]
export let goodsSort = collationRules
export let Cshow = [
  {
    label: '是',
    value: true
  },
  {
    label: '否',
    value: false
  }
]
export let groupGoodsLabels = [
//   {
//     label: '浏览量',
//     value: 'goodsOtherInfoDTO.saleVolume'
//   },
  //   {
  //     label: '库存',
  //     value: 'goodsOtherInfoDTO.stockQuantity'
  //   },
//   {
//     label: '销量',
//     value: 'goodsOtherInfoDTO.saleVolume'
//   },
  {
    label: '发布时间',
    value: 'putOnSaleTime'
  },
  {
    label: '类型',
    value: 'goods_type'
  },
  {
    label: '分组',
    value: 'goodsDTO.goodsData.groupName'
  }
]
